'use client';

import { useEffect } from 'react';

import { usePathname } from 'next/navigation';

import { useAppDispatch } from '@/store';
import { clearPetCreationState, setActiveStep, setInnerSteps } from '@/store/slices/petRecommendations';

export default function UnloadRecommendations() {
  const dispatch = useAppDispatch();

  const pathname = usePathname();

  useEffect(() => {
    if (!pathname.includes('petprofile/createrecommendationnew')) {
      dispatch(setActiveStep(1));
      dispatch(setInnerSteps([1, 1, 1, 1]));
      dispatch(clearPetCreationState());
    }
  }, [pathname, dispatch]);

  return null;
}
